import { BexApiStore } from 'bernie-graphql';

export class BaseBexApiStore extends BexApiStore {
  public toJSON(ignoreAdditionalKeys: string[] | string = []) {
    const serializedState = super.toJSON(ignoreAdditionalKeys);

    if (serializedState?.bexApiSource?.headers) {
      delete serializedState.bexApiSource['headers'];
    }

    return serializedState;
  }
}
